var tychei = {exports: {}};

export { tychei as __module };
//# sourceMappingURL=tychei.js.map
